import axiosInstance from '../../middleware/api'

const API_BASE_URL = '/api/v2/whiteboard';

export const whiteboardService = {
    createWhiteboard: async (whiteboardData) => {
        const response = await axiosInstance.post(`${API_BASE_URL}`, whiteboardData);
        return response.data;
    },

    getWhiteboards: async (boardId) => {
        const response = await axiosInstance.get(`${API_BASE_URL}?board_id=${boardId}`);
        return response.data;
    },

    updateWhiteboard: async (id, whiteboardData) => {
        const response = await axiosInstance.put(`${API_BASE_URL}/${id}`, whiteboardData);
        return response.data;
    },

    deleteWhiteboard: async (id, boardId) => {
        console.log(id, boardId)
        const response = await axiosInstance.delete(`${API_BASE_URL}/${id}`, {
            params: {
                board_id: boardId
            }
        });
        return response.data;
    }
};